import { isDesktop } from "react-device-detect";
import BonusGameController from "../../controllers/bonus/BonusGameController";
import MainGridController from "../../controllers/grid/MainGridController";
import { COMPONENTS } from "../../lib/constants";
import { BonusGameGridView } from "./BonusGameGridView";
import { BonusGameItems } from "./BonusItems";

export const BonusGameView = {
  name: COMPONENTS.BONUS_GAME,
  position: {
    x: 0,
    y: 0,
  },
  controllers: [
    {
      Controller: BonusGameController,
      name: "BonusGameController",
      config: {
        item: "bonus_game_wrapper",
        val: "bonus_game_wrapper",
      },
    },
    {
      Controller: MainGridController,
      name: "BonusGameViewGrid",
      config: BonusGameGridView,
    },
  ],
  components: [
    {
      name: "fg_holder",
      type: "Sprite",
      components: [
        isDesktop
          ? {
              name: "bonus_fg",
              type: "AnimatedSprite",
              position: {
                x: 0,
                y: 210,
              },
              animation: {
                pattern: "MS$.png",
                start: 0,
                end: 89,
                speed: 0.5,
                precision: 2,
                loop: true,
                scale: {
                  x: isDesktop ? 1 : 2,
                  y: isDesktop ? 1 : 2,
                },
              },
            }
          : {
              name: "bonus_fg",
              type: "Sprite",
              position: {
                x: 0,
                y: 170,
              },
              scale: {
                x: 1.3,
                y: 1.3,
              },
              img: "main_character_m",
            },
        isDesktop && {
          name: "bonus_fg_wow",
          type: "AnimatedSprite",
          position: {
            x: 10,
            y: 205,
          },
          animation: {
            pattern: "Active$.png",
            start: 0,
            end: 67,
            speed: 0.5,
            precision: 2,
            loop: false,
            scale: {
              x: isDesktop ? 0.61 : 1,
              y: isDesktop ? 0.61 : 1,
            },
          },
        },
      ],
    },
    {
      name: "btn_holder",
      type: "Sprite",
      components: [
        {
          name: "bonus_btn",
          type: "StopButton",
          position: { x: 0, y: 0 },
          bg: "spin_btn",
          bg_icon: "stop_icon",
          animation: {
            pattern: "plbt$.png",
            start: 0,
            end: 24,
            speed: 0.5,
            loop: true,
          },
        },
      ],
    },
    {
      name: "win_bg_wrapper",
      type: "Sprite",
      components: [
        {
          name: "win_bg",
          type: "Sprite",
          img: "bonus_total_win_bg",
          position: { x: 0, y: 0 },
        },
        {
          name: "win_bg_border",
          type: "AnimatedSprite",
          position: { x: -20, y: -30 },
          animation: {
            pattern: "sfs$.png",
            start: 0,
            end: 29,
            speed: 0.5,
            precision: 2,
            loop: true,
            scale: {
              x: isDesktop ? 1 : 1,
              y: isDesktop ? 1 : 1,
            },
          },
        },
        {
          name: "win_bg_border",
          type: "AnimatedSprite",
          position: { x: -20, y: 72 },
          animation: {
            pattern: "sfs$.png",
            start: 0,
            end: 29,
            speed: 0.5,
            precision: 2,
            loop: true,
            scale: {
              x: isDesktop ? 1 : 1,
              y: isDesktop ? 1 : 1,
            },
          },
        },
        {
          name: "win_text",
          type: "Text",
          text: "BONUS_WIN_TEXT",
          position: { x: 373 / 2 - 20, y: 5 },
          anchor: { x: 0.5, y: 0 },
        },
        {
          name: "win_value",
          type: "Text",
          text: "BONUS_WIN_VALUE",
          position: { x: 373 / 2 - 20, y: 30 },

          anchor: { x: 0.5, y: 0 },
        },
      ],
    },
    {
      name: "BonusItems",
      type: "VisualComponent",
      component: BonusGameItems,
    },
  ],
};
